module.exports = __webpack_public_path__ + "static/media/exit-ramp.197f1c1a.png";